$(document).ready(function(){
	objectFitImages();
});